import http from '../HttpWrapper'

class WarmupApi {
    public async warmup(recaptchaToken: string): Promise<void> {
        console.log('WarmupApi.warmup called')
        await http.post(
            '/warmup',
            { recaptchaToken },
            undefined,
            undefined,
            false,
        )
    }
}

const warmupApi = new WarmupApi()
export default warmupApi
